<template>
  <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      clipped
      :width="$vuetify.breakpoint.mobile ? '100%' : 300"
      :mini-variant.sync="mini"
      mobile-breakpoint="0"
      mini-variant-width="75"
      style="min-width: 75px;"
    >
    <v-list-item class="px-2">
      <v-btn block text @click.stop="mini = !mini" class="d-flex justify-end" >
        <v-icon v-if="mini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <div v-if="canContactsWrite || canContactsManagePersonal">
      <v-btn v-if="!mini" rounded class="ml-4 mt-3 mb-2"
        @click="openContactCreateForm()"
        data-testid="contacts-drawer-create">
        <v-icon left color="primary">
          mdi-plus
        </v-icon>
        <span>{{ $t('contacts.btn.newContact') }}</span>
      </v-btn>
      <v-btn v-else block icon class="px-2"
        @click="openContactCreateForm()"
        data-testid="contacts-drawer-create">
        <v-icon color="primary">
          mdi-plus
        </v-icon>
      </v-btn>
    </div>
    <DrawerList/>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Contact from 'Store/class/contact/contact'
import DrawerList from './list'
export default {
  name: 'contacts-drawer',
  components: {
    DrawerList
  },
  data () {
    return {
      dialog: false,
      drawer: null,
      mini: this.$vuetify.breakpoint.mobile
    }
  },
  mounted () {
    this.getTags()
    this.getPersonalTags()
  },
  watch: {
    filterByTags () {
      this.getContacts()
    },
    searchText () {
      this.getContacts()
    }
  },
  computed: {
    ...mapGetters({
      canContactsRead: 'permissions/contactsRead',
      canContactsWrite: 'permissions/contactsWrite',
      canContactsManagePersonal: 'permissions/contactsManagePersonal',
      tags: 'contacts/tags/tags',
      personalTags: 'contacts/personalTags/personalTags',
      getFilterByTags: 'contacts/filterByTags',
      getFilterByPersonalTags: 'contacts/filterByPersonalTags',
      searchText: 'search/searchText'
    }),
    filterByTags: { get () { return this.getFilterByTags }, set (filterByTags) { this.setFilterByTags(filterByTags) } },
    filterByPersonalTags: { get () { return this.getFilterByPersonalTags }, set (filterByPersonalTags) { this.setFilterByPersonalTags(filterByPersonalTags) } }
  },
  methods: {
    ...mapActions({
      getContacts: 'contacts/get',
      getTags: 'contacts/tags/get',
      getPersonalTags: 'contacts/personalTags/get',
      openTagDialog: 'contacts/tagForm/open',
      setFilterByTags: 'contacts/setFilterByTags',
      setFilterByPersonalTags: 'contacts/setFilterByPersonalTags',
      openContactForm: 'contacts/form/open'
    }),

    openContactCreateForm () {
      const isUpdate = false
      const contact = new Contact({})
      this.openContactForm({ contact, isUpdate })
    }
  }
}
</script>

<style>
</style>
